import { styled } from '@zoopla-eng/zds-components/themes';

export const StyledSearchPath = styled('span', {
    textTransform: 'capitalize'
});

export const StyledSmallLabels = styled('p', {
    fontGroup: 'fork',
    color: '$textTitle',
    fontWeight: '$200'
});
